import React, {  Component } from 'react';

export default class SelectLayoutOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: true,
			layout: 'landscape'
        }
    }

	componentDidMount() {
		// window.scrollTo(0, 0);
	}

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
    }

	handleChangeLayout(layout, event) {
		this.setState({
			layout: layout
		})
	}

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="selectLayoutOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
					<a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Select Layout</h2>
                    <p className="bold">Note that the portrait option will only be applied to pages with one product.</p>
					<form className="selectLayoutForm" name="selectLayoutForm" id="selectLayoutForm" action="">
				        <table className="formTableTypeA selectLayoutFormTable">
				          	<tbody>
					            <tr>
									<td className="radio">
										<input type="radio" onClick={this.handleChangeLayout.bind(this, "portrait")} name="layout" defaultValue="portrait" id="layoutPortrait" defaultChecked={this.props.brochure.layout==="portrait"?true:false} />
									</td>
									<td className="icon">
										<label htmlFor="layoutPortrait">
											<img className="icon" src="../images/icon-layout-portrait.png" width={24} height={29} alt="" />
										</label>
									</td>
									<td className="text">
										<label htmlFor="layoutPortrait">
											<strong>Portrait</strong>
										</label>
									</td>
					            </tr>
					            <tr>
									<td className="radio">
										<input type="radio" onClick={this.handleChangeLayout.bind(this, "landscape")} name="layout" defaultValue="landscape" id="layoutLandscape" defaultChecked={this.props.brochure.layout==="landscape"?true:false} />
									</td>
									<td className="icon">
										<label htmlFor="layoutLandscape">
											<img className="icon" src="../images/icon-layout-landscape.png" width={29} height={24} alt="" />
										</label>
									</td>
									<td className="text">
										<label htmlFor="layoutLandscape">
											<strong>Landscape</strong>
										</label>
									</td>
					            </tr>
				          	</tbody>
				        </table>
				        <div className="noButtonContainer">
							<button className="noButton blueButton" onClick={this.closeDialog.bind(this)}>Cancel</button>
				        </div>
				        <div className="yesButtonContainer">
				          	<input type="submit" className="yesButton" onClick={this.props.handleContinueNextStep.bind(this, this.state.layout)} value="Continue" />
				        </div>
			      	</form>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/selectLayoutOverlayDialog.js